import { ContentContainer } from '../../components/ContentContainer';
import {
  PriceRangeDisplay,
  PrimaryAtmosphereDisplay,
  AmenitiesDisplay,
  ReservationPolicyDisplay,
} from '../../components/VenueDisplay';
import type { WineryVenueDetailsProps } from './types';

const UnknownValue = () => (
  <span className="text-sm text-gray-400 italic">Unknown</span>
);

export const WineryVenueDetails = ({
  priceRange,
  primaryAtmosphere,
  amenities,
  reservationPolicy,
}: WineryVenueDetailsProps) => {
  return (
    <ContentContainer>
      <h2 className="text-xl font-semibold text-gray-900 mb-4">Venue Details</h2>
      <div className="space-y-3">
        <div>
          <span className="text-sm font-medium text-gray-600 block mb-1">Price Range</span>
          {priceRange ? <PriceRangeDisplay value={priceRange} /> : <UnknownValue />}
        </div>

        <div>
          <span className="text-sm font-medium text-gray-600 block mb-1">Atmosphere</span>
          {primaryAtmosphere ? (
            <PrimaryAtmosphereDisplay value={primaryAtmosphere} />
          ) : (
            <UnknownValue />
          )}
        </div>

        <div>
          <span className="text-sm font-medium text-gray-600 block mb-1">Reservations</span>
          <ReservationPolicyDisplay value={reservationPolicy} />
        </div>

        {amenities.length > 0 && (
          <div>
            <span className="text-sm font-medium text-gray-600 block mb-1">Amenities</span>
            <AmenitiesDisplay value={amenities} showAll />
          </div>
        )}
      </div>
    </ContentContainer>
  );
};
